import { css } from 'lit';

export const alertStyles = css`
  wa-callout {
    color: var(--wa-color-text-normal);
  }
`;
